import { InputBase, Toolbar } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import { DataTable, FilterSection, SelectField, StyledButton } from '../../../../../components'
import { ImportIcon, searchIcon } from '../../../../../assets/icons'
import AddEmployee from './components/AddEmployee'
import EmployeeDetail from './components/EmployeeDetail'
import { employeeHeadCells } from '../../../../../shared/data/headCells'
import { useDispatch, useSelector } from 'react-redux'
import { useGlobal } from '../../../../../shared'
import { urls } from '../../../../../shared/config'
import { setSearchItem } from '../../../../../redux/globalSlice'
import { EditEmployee } from './components/EditEmployee'
import { InfoField } from '../School/PopOver/SchoolInfo'
import { highestInt } from '../../../../../shared/utils/constants'
import { downloadCSV } from '../../../../../shared/config/downloadCSV'

const Employee = () => {
  const [page, setPage] = React.useState(1)
  const rowsPerPage = useSelector((state) => state.global.rowsPerPage)
  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type
  const [schoolName, setSchoolName] = React.useState('')
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name

  // const search = useSelector((state) => state.global.searchItem)
  const [searchInput, setSearchInput] = useState('') // immediate input value
  const [search, setSearch] = useState('')

  const {
    data: empData,
    count: empCount,
    refetch,
  } = useGlobal({
    userUrl: `${urls.EMPLOYEE_GET}${customRole == 'Admin' ? userSchoolId : schoolName}&page=${page}&limit=${rowsPerPage}&keyword=${search}`,
  })
  // const { data: searchEmp, count: searchCount } = useGlobal({
  //   userUrl: `${urls.EMPLOYEE_SEARCH}${search}&school_id=${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName}&page=${page}&limit=${rowsPerPage}`,
  // })
  const [update, setUpdate] = useState(false)

  const dispatch = useDispatch()
  const rows = empData
  const pagecount = empCount
  // debounced value used in API call

  // Debounce effect: update 'search' after 300ms of inactivity
  useEffect(() => {
    const handler = setTimeout(() => {
      setSearch(searchInput)
      // Optional: reset to first page when search term changes
      setPage(1)
    }, 300)

    return () => clearTimeout(handler)
  }, [searchInput])

  const [addEmployee, setAddEmployee] = useState(false)
  const [detail, setDetail] = useState(false)
  const handleExport = () => {
    if (rows && rows?.length > 0) {
      // Generate filename with current date
      const date = new Date().toISOString().split('T')[0]
      downloadCSV(rows, `Employees_${date}`)
    } else {
      alert('No data to export')
    }
  }
  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Employee'} subtitle={'Dashboard / Employee'} />
      <div className="school-toolbar">
        <div style={{ width: '40%' }}>
          {customRole != 'Admin' ? (
            <SelectField
              placeholder={'Select School'}
              options={(schoolList || [])?.map((prod) => ({
                value: prod.school_id,
                label: prod.school_name,
              }))}
              name="schoolName"
              value={schoolName}
              onChange={(selectedOption) => {
                setSchoolName(selectedOption)
                setPage(1)
              }}
            />
          ) : (
            <InfoField value={userSchoolName} />
          )}
        </div>
      </div>

      <div className="employee-toolbar">
        <InputBase
          placeholder="Search"
          sx={{ width: '200px' }}
          className="search-component"
          value={searchInput} // bind to immediate input state
          onChange={(e) => setSearchInput(e.target.value)}
          startAdornment={<img src={searchIcon} alt="" style={{ width: '16px', height: '16px' }} />}
        />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
          }}
        >
          <FilterSection icon={ImportIcon} onClick={handleExport} title={'Export'} />
          <StyledButton width={'128px'} onClick={() => setAddEmployee(true)}>
            + Add New
          </StyledButton>
        </div>
      </div>
      <DataTable
        headCells={employeeHeadCells}
        rowData={rows}
        emp
        setUpdate={setUpdate}
        handleDetailOpen={() => setDetail(true)}
        pageFee={page}
        setPageFee={setPage}
        pages
        pageCount={pagecount}
        refetch={refetch}
      />
      {addEmployee && (
        <AddEmployee
          customRole={customRole}
          userSchoolId={userSchoolId}
          title={'Add Employee'}
          open={addEmployee}
          handleClose={() => setAddEmployee(false)}
        />
      )}
      {detail && <EmployeeDetail open={detail} handleClose={() => setDetail(false)} />}
      {update && <EditEmployee open={update} handleClose={() => setUpdate(false)} />}
    </div>
  )
}

export default Employee
